// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copy-resonator-modal .MuiDialog-paperScrollPaper{background-color:#a8edf6}#select_follower,#select_follower_group{width:200px}\n", ""]);
// Exports
module.exports = exports;
